import { apiAxiosCMS } from 'services/api';
import { ItemScreenStatic } from 'types/ScreensStaticsProps'; // ajuste o caminho conforme seu projeto

export async function getScreensStatics(
	handleNotify: any
): Promise<ItemScreenStatic[]> {
	const screens: ItemScreenStatic[] = await apiAxiosCMS
		.get('/static-pages')
		.then((res) => {
			if (res?.data.length > 0) {
				return res.data;
			} else {
				return [];
			}
		})
		.catch(() => {
			handleNotify('Erro ao buscar os dados das telas estáticas', 'error');
			return [];
		});

	return screens;
}
